var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.disabled)?_c('v-select',{attrs:{"value":_vm.value.wish.comment,"items":_vm.items,"label":"Anzahl Doppellektionen","single-line":"","required":"","clearable":""},on:{"change":_vm.update}}):_c('span',[_vm._v(_vm._s(_vm.value.wish.comment || "–"))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }